import { useQuery } from "@tanstack/react-query"
import { getBackofficeCustomerQuery } from "modules/backoffice/lib/customers/getBackofficeCustomerQuery"

export function useGetBackofficeCustomerQuery(
  ...args: Parameters<typeof getBackofficeCustomerQuery>
) {
  return useQuery(getBackofficeCustomerQuery(...args))
}
